import { computed } from "mobx";
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from "react-router-dom";
import { usePipedriveStore } from '../..';
import useCircleWithRadiusOnMap from "../../hooks/useCircleWithRadiusOnMap";
import useNearestLocations from "../../hooks/useNearestLocations";
import useRadiusCompanyIdsOnMap from "../../hooks/useRadiusCompanyIdsOnMap";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { distinctBy } from "../../utils/utils";
import RadiusDropdown from "../RadiusDropdown";
import NearestLocationsGrid from "../locations/NearestLocationsGrid";

function DealDetailsCompaniesTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const pipedriveStore = usePipedriveStore();
    const currentDeal = useMemo(() => computed(() => pipedriveStore.deals.find(d => d.id.toString() === id)!), [id]).get();
    const coordinates = useMemo(() => ({ latitude: currentDeal.lat, longitude: currentDeal.lon }), [currentDeal]);
    const [radius, setRadius] = useState(5);
    const nearestLocations = useNearestLocations(coordinates, radius);
    useCircleWithRadiusOnMap(coordinates, radius, visible, "DealDetailsCompaniesTab");
    useRadiusCompanyIdsOnMap(nearestLocations, visible);

    useEffect(() => setEntityCount(distinctBy(nearestLocations, l => l.pipedriveCompanyId).length), [nearestLocations, setEntityCount]);

    if (!visible)
        return null;

    return (
        <NearestLocationsGrid
            locations={nearestLocations}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(DealDetailsCompaniesTab);
